import { useEffect, useState, type ReactNode } from "react";
import { API_BASE_URL, CLOUD_MODE } from "../config/env";

export function CloudGate({ children }: { children: ReactNode }) {
  const [state, setState] = useState<"loading" | "ready" | "error">(CLOUD_MODE ? "loading" : "ready");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!CLOUD_MODE) return;
    const controller = new AbortController();
    setState("loading");
    void fetch(`${API_BASE_URL}/auth/me`, { credentials: "include", signal: controller.signal }).then(response => {
      if (response.status === 401) { location.replace(`/account/?returnTo=${encodeURIComponent(location.pathname + location.search)}`); return; }
      if (!response.ok) throw new Error("AUTH_UNAVAILABLE");
      setState("ready");
    }).catch(() => { if (!controller.signal.aborted) setState("error"); });
    return () => controller.abort();
  }, [attempt]);
  if (state === "ready") return children;
  return <main className="cloud-session" aria-live="polite">
    <img src="/brand/zch-logo.png" alt="ZCH" width="160" />
    <h1>{state === "loading" ? "正在打开创作工作台…" : "暂时无法验证登录状态"}</h1>
    {state === "error" ? <><p>请检查网络后重试，你的云端项目仍会保留。</p><button type="button" onClick={() => setAttempt(value => value + 1)}>重新连接</button><a href="/account/">打开账户中心</a></> : null}
  </main>;
}
